import React, { Fragment } from 'react'
import { Typography, Button, Icon } from 'antd'
import NewHeader from '../../../components/NewHeader'
import history from '../../../history'

const { Title } = Typography
const QuestHeader = ({ t, type }) => {
  return (
    <Fragment>
      <div className="create-course">
        <div className="create-course__content">
          {type === "Create" && <Title level={4}>Create Quest</Title>}
        </div>
        <NewHeader />
      </div>
    </Fragment>
  )
}

export default QuestHeader
